import { Check, X, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

const doItems = [
  "Move items that may get wet to dry areas",
  "Move items that can transfer color (rugs, draperies, bedding) from carpets/floors",
  "Mop up excess water (except sewer backup — leave that to us)",
  "Document your loss for your insurance claim",
];

const dontItems = [
  "Don't use any appliances or electronics — shut off power",
  "Don't vacuum up water due to electrocution risk",
];

export const EmergencyChecklistSection = () => {
  return (
    <section className="py-8 bg-destructive/10">
      <div className="max-w-3xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-5">
          <div>
            <h2 className="text-xl font-bold text-foreground">What To Do After a Water Loss</h2>
            <p className="text-sm text-muted-foreground">We will arrive in less than 60 mins, ready to work.</p>
          </div>
          <Link 
            to="/60-minute-water-damage-survival-guide" 
            className="inline-flex items-center gap-1 text-sm text-wtr-blue hover:underline font-semibold whitespace-nowrap"
          >
            <BookOpen className="w-4 h-4" />
            Full Survival Guide →
          </Link>
        </div>
        
        <ul className="space-y-2 mb-4">
          {doItems.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-foreground">
              <Check className="w-4 h-4 text-green-600 shrink-0 mt-0.5" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <ul className="space-y-2">
          {dontItems.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-foreground">
              <X className="w-4 h-4 text-destructive shrink-0 mt-0.5" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};